import View from './view/CanViewReportInitialState'

const { Record } = require('immutable');

export default Record({
    view: View()
});